// Cursor-reactive background glow.
//
// Updates the --mx / --my CSS custom properties that background.css reads to
// position its radial blooms. The cursor only nudges the glows by a small
// parallax amount (DRIFT either side of a fixed base) rather than tracking it
// across the whole viewport — deliberately subtle so it isn't distracting.
// Movement is rAF-lerped and listeners are passive. Under prefers-reduced-motion
// we return early, leaving the glow completely static.
export default function glow() {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        return;
    }

    // Maximum drift from the base position, as a fraction of the viewport.
    const DRIFT = 0.06;
    const BASE_X = 0.5;
    const BASE_Y = 0.3;

    const root = document.documentElement;
    let targetX = BASE_X;
    let targetY = BASE_Y;
    let currentX = BASE_X;
    let currentY = BASE_Y;
    let raf = null;

    function tick() {
        currentX += (targetX - currentX) * 0.05;
        currentY += (targetY - currentY) * 0.05;
        root.style.setProperty('--mx', currentX.toFixed(4));
        root.style.setProperty('--my', currentY.toFixed(4));

        if (Math.abs(targetX - currentX) > 0.0005 || Math.abs(targetY - currentY) > 0.0005) {
            raf = requestAnimationFrame(tick);
        } else {
            raf = null;
        }
    }

    function schedule() {
        if (raf === null) {
            raf = requestAnimationFrame(tick);
        }
    }

    window.addEventListener('pointermove', (event) => {
        targetX = BASE_X + ((event.clientX / window.innerWidth) - 0.5) * (DRIFT * 2);
        targetY = BASE_Y + ((event.clientY / window.innerHeight) - 0.5) * (DRIFT * 2);
        schedule();
    }, { passive: true });
}
